import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
  FieldTimeOutlined,
  ReloadOutlined,
  SyncOutlined,
} from '@ant-design/icons';
import { Button, Card, Col, Row, Space, Statistic, Typography } from 'antd';
import { useQueueStats } from '../api/hooks';

const { Title, Text } = Typography;

export default function QueuePage() {
  const { data, isLoading, refetch } = useQueueStats(5_000);

  const cards = [
    { title: 'Đang chờ', value: data?.waiting, icon: <ClockCircleOutlined />, color: undefined },
    {
      title: 'Đang xử lý',
      value: data?.active,
      icon: <SyncOutlined spin />,
      color: '#1677ff',
    },
    {
      title: 'Hoàn tất',
      value: data?.completed,
      icon: <CheckCircleOutlined />,
      color: '#52c41a',
    },
    {
      title: 'Thất bại',
      value: data?.failed,
      icon: <CloseCircleOutlined />,
      color: '#ff4d4f',
    },
    {
      title: 'Trì hoãn',
      value: data?.delayed,
      icon: <FieldTimeOutlined />,
      color: '#faad14',
    },
  ];

  return (
    <div>
      <Space style={{ width: '100%', justifyContent: 'space-between', marginBottom: 16 }}>
        <Title level={3} style={{ margin: 0 }}>
          Hàng đợi
        </Title>
        <Space>
          <Text type="secondary">Tự động làm mới mỗi 5 giây</Text>
          <Button icon={<ReloadOutlined />} onClick={() => refetch()}>
            Làm mới
          </Button>
        </Space>
      </Space>

      <Row gutter={[16, 16]}>
        {cards.map((c) => (
          <Col xs={12} sm={8} lg={6} key={c.title}>
            <Card>
              <Statistic
                title={c.title}
                value={c.value ?? 0}
                loading={isLoading}
                prefix={c.icon}
                valueStyle={c.color ? { color: c.color } : undefined}
              />
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
}
